import React, { FC } from 'react'

import Code from '../Code'

import Phone from './Phone'

type Props = {
  canAutoSubmitCode: boolean
  checkouting: boolean
  codeInputRef: React.MutableRefObject<HTMLInputElement | null>
  handleResend: () => void
  onSubmit: () => void
  phonePanelTitle: string
  phoneSectionDescription: string | null
  resendSecondsLeft: number
  showSmsVerifiedBadge: boolean
  signUpLoading: boolean
  stateIsCode: boolean
  stateIsPhone: boolean
}

const PhoneVerification: FC<Props> = ({
  canAutoSubmitCode,
  checkouting,
  codeInputRef,
  handleResend,
  onSubmit,
  phonePanelTitle,
  phoneSectionDescription,
  resendSecondsLeft,
  showSmsVerifiedBadge,
  signUpLoading,
  stateIsCode,
  stateIsPhone,
}) => {
  return (
    <section className="checkout-contact-flow__panel checkout-contact-flow__panel--phone">
      <div className="checkout-contact-flow__title-row">
        <h3 className="checkout-contact-flow__title">{phonePanelTitle}</h3>
        {showSmsVerifiedBadge ? (
          <span aria-label="Phone verified" className="checkout-contact-flow__verified-badge" role="img">
            <svg aria-hidden="true" className="checkout-contact-flow__verified-icon" fill="none" viewBox="0 0 20 20">
              <g className="checkout-contact-flow__verified-circle-group">
                <circle cx="10" cy="10" r="8.5" />
              </g>
              <g className="checkout-contact-flow__verified-check-group">
                <path d="M6.2 10.4 8.8 13 13.8 8" />
              </g>
            </svg>
          </span>
        ) : null}
      </div>
      {phoneSectionDescription ? (
        <p className="checkout-contact-flow__description mb-1">{phoneSectionDescription}</p>
      ) : null}
      <Phone disabled={!stateIsPhone} submitting={signUpLoading || checkouting} />
      <div aria-hidden={!stateIsCode} className="checkout-contact-flow__code-reveal" hidden={!stateIsCode}>
        {stateIsCode ? (
          <Code
            canAutoSubmit={canAutoSubmitCode}
            codeInputRef={codeInputRef}
            handleResend={handleResend}
            handleSubmitCode={onSubmit}
            resendSecondsLeft={resendSecondsLeft}
          />
        ) : null}
      </div>
    </section>
  )
}

export default PhoneVerification
export { getPhoneSectionDescription } from './phoneSectionDescription'
